import axios from "axios";

import { env } from "../config";

const BASE_URL = env.API_ENDPOINT; // Replace with your actual base URL
//const BASE_URL = "http://localhost:4000"; // Replace with your actual base URL

const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

export { axiosPrivate };
